export const blockIconsPlacesVilla = (
	<span className='material-symbols-outlined'>villa</span>
);
